<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
		
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>

                        <el-form-item :label="$t('applyList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('applyList.statusStr.0')" :value="0"></el-option>
								<el-option :label="$t('applyList.statusStr.1')" :value="1"></el-option>
								<el-option :label="$t('applyList.statusStr.2')" :value="2"></el-option>
								<el-option :label="$t('applyList.statusStr.3')" :value="3"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('applyList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
                <el-table-column align="center" prop="id" width="50" label="ID">
				</el-table-column>
                <el-table-column align="center" prop="money" width="100" :label="$t('applyList.money')">
				</el-table-column>
				<el-table-column align="center" prop="trc" :label="$t('applyList.rechargeAddress')">
				</el-table-column>
				
                <el-table-column align="center" prop="status" width="100" :label="$t('applyList.status')">
                    <template slot-scope="scope">
						<span v-if="scope.row.status == 0">{{$t('applyList.statusStr.0') }}</span>
						<span v-if="scope.row.status == 1" class="text-success">{{$t('applyList.statusStr.1') }}</span>
						<span v-if="scope.row.status == 2" class="text-danger">{{$t('applyList.statusStr.2') }}</span>
						<span v-if="scope.row.status == 3" class="text_chengse">{{$t('applyList.statusStr.3') }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="remark" :label="$t('applyList.remark')">
                    <template slot-scope="scope">
									<div v-if="scope.row.remark.length > 10">
										{{ scope.row.remark.substring(0, 10) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.remark)">{{$t('system.look')}}</el-button>
									</div>
									<div v-else>
										<div v-if="scope.row.remark.length > 0">{{ scope.row.remark }}</div>
										<div v-else> -- </div>
									</div>
								</template>
				</el-table-column>
				<el-table-column align="center" prop="create_time" width="190" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center"  width="100" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" :disabled="scope.row.status !== 0" plain type="primary" v-auth="'editAdmin'" @click="cancelModel(scope)">{{$t('layout.cancel')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

        

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('applyList.edit') : $t('applyList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('applyList.money')" prop="money">
					<el-input v-model="form.money" type="number" clearable size="small" :placeholder="$t('applyList.money')"  style="width: 85%;"></el-input>
				</el-form-item>
            
                <el-form-item v-if="form.type == 2" :label="$t('applyList.upApply')" prop="parent">
					<el-select v-model="form.parent" size="small" filterable :placeholder="$t('system.select')" style="width: 85%;">
						<el-option v-for="item in Apply_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>


        <el-dialog :close-on-click-modal="false"
           :title="$t('applyList.rechargeAddress')"
           :visible.sync="payInfoModel"
           top="5vh"
           :width="layout.is_phone?'90%':'80%'"
           :append-to-body="true"
           @close="hidePayModel"
           custom-class="custom-dialog">
            <!-- 表单内容 -->
            <el-form style="max-height: 65vh; overflow: auto;" label-position="top" class="recharge-form">
                <!-- 金额输入 -->
                <el-form-item :label="$t('applyList.amount')">
                <el-input 
                    v-model="pay_info.money"
                    type="number"
                    readonly
                    :placeholder="$t('applyList.amountPlaceholder')"
                    clearable>
                    <template slot="append">{{ currencySymbol }}</template>
                </el-input>
                </el-form-item>

                <!-- 充值地址 -->
                <el-form-item :label="$t('applyList.rechargeAddress')">
                <el-input 
                    v-model="pay_info.trc"
                    readonly
                    class="address-input">
                    <el-button 
                    slot="append" 
                    icon="el-icon-document-copy"
                    @click="copyAddress">
                    </el-button>
                </el-input>
                </el-form-item>

                <!-- 二维码展示 -->
                <el-form-item v-if="pay_info.img_url" :label="$t('applyList.qrCode')">
                <div class="qrcode-container">
                    <img 
                    :src="pay_info.img_url" 
                    alt="充值二维码"
                    class="qrcode-image"
                    >
                    <p class="qrcode-tip">{{ $t('applyList.scanTip') }}</p>
                </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="hidePayModel">{{$t('system.confirm')}}</el-button>
            </div>
        </el-dialog>
		<el-dialog :close-on-click-modal="false" :width="layout.is_phone?'90%':'80%'" :append-to-body="true"  :visible.sync="dialogTitleVisible" :title="$t('cloudList.loginUrl')">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				dialogTitleVisible: false,
				fullTitle: '',

                payInfoModel: false,

				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
                    status:-1,
					time:[],
				},
				auth_val: 'Apply',

                prop: 'id',
                sort: 'descending',
				currencySymbol:0,
				preUrl: "user/applyList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delApply", //删除單条地址
				// addUrl: "user/addApply", //添加/修改地址
				editStatusUrl:"user/editStatusApply",//修改狀態地址

				pay_info: [],

				tableData: [],
				form: {
                    money: "",
				},
				rules: {
					money: [
                        {
                            required: true,
                            message: this.$t('applyList.applyMoney'),
                            trigger: 'blur'
                        },
                        {
                            validator: (rule, value, callback) => {
                            if (value <= 0) {
                                callback(new Error(this.$t('applyList.applyMoney')))
                            } else {
                                callback()
                            }
                            },
                            trigger: ['blur', 'change']
                        }
                    ]
				},
				Apply_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			// this.commonList(['Apply']);
		},
		methods: {
            hidePayModel() {
            	// 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
				this.editIndex = -1
                this.createModel = false
                this.payInfoModel = false
				this.getList()
            },
			   // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
            cancelModel(res){
				 // 添加确认对话框
				 this.$confirm(
					this.$t('message.cancelConfirm'), // 确认提示内容
					this.$t('message.confirmTitle'),  // 对话框标题
					{
						confirmButtonText: this.$t('system.confirm'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}
				).then(() => {
					// 用户确认后执行原逻辑
					this.layout.loading = true;
					this.axios.post('/admin/user/editStatusApply', {
						id: res.row.id,
					}, {
						token: true
					}).then(res => {
						let all = res.data
						if (all.code == 1) {
							this.$message({
								message: all.msg,
								type: 'success'
							}); // 控制是否顯示成功提示
						}
						this.layout.loading = false;
						this.loading = false;
						this.getList()
					}).catch(err => {
						this.layout.loading = false;
						this.userInfoModel = false;
					})
				}).catch(() => {
					// 用户取消时可选操作
					this.$message({
						type: 'info',
						message: this.$t('message.cancelOperate')
					});
				});
            },
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
                        this.layout.loading = true;
                        this.axios.post('/admin/user/addApply', this.form, {
                            token: true
                        }).then(res => {
                            let all = res.data
                            
                            if (all.code == 1) {
                                this.pay_info = all.data
                                this.payInfoModel = true
                            }
                            this.layout.loading = false;
                            this.loading = false;
                        }).catch(err => {
                            this.layout.loading = false;
                            this.userInfoModel = false;
                        })
					}
				})
			},
			hide(){
                // 初始化表單
				this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
					this.editIndex = -1
                    this.createModel = false
            },
            copyAddress() {
                // 实现复制地址逻辑
                navigator.clipboard.writeText(this.pay_info.trc)
            },
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						name_lang: '',
						type: 1,
						parent: '',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						name_lang: e.row.name_lang,
						type:  e.row.type,
						parent:  e.row.parent,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			// commonList(type) {
			// 	this.layout.loading = true;
			// 	this.axios.post('/admin/user/commonList', {
			// 		type: type,
			// 	}, {
			// 		token: true,
			// 	}).then(res => {
			// 		let all = res.data
			// 		let list = all.data.list
			// 		this.Apply_list = list.Apply

			// 		this.layout.loading = false;
			// 	}).catch(err => {
			// 		// 失敗
			// 		this.layout.loading = false;
			// 	})
			// },
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					status:-1,
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			
		}
	}
</script>
<style lang="scss"> /* 使用 SCSS/SASS 预处理器 */
    .recharge-form {
  .el-form-item__label {
    font-weight: bold;
  }

  .address-input {
    .el-input__inner {
      font-family: monospace; /* 更适合地址显示 */
    }
  }

  .qrcode-container {
    text-align: center;
    margin: 0 auto;
    
    .qrcode-image {
      width: 200px;
      height: 200px;
      border: 1px solid #eee;
      padding: 10px;
      border-radius: 4px;
      @media (max-width: 768px) {
        width: 150px;
        height: 150px;
      }
    }

    .qrcode-placeholder {
      width: 200px;
      height: 200px;
      background: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      margin: 0 auto;
    }

    .qrcode-tip {
      color: #666;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>

